module.exports = __webpack_public_path__ + "img/solution2.9a9102a5.png";